import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { CognitoService } from '../../services/cognito.service';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';

@Component({
  selector: 'app-forgot-password',
  template: `
<form [formGroup]="forgotForm" class="dashboard-tile mat-elevation-z4">
  <div class="tile-header">
    <div class="tile-header-title">
      Forgot Password
    </div>
  </div>
  <div class="tile-content">
    <img mat-card-image class="tile-logo" src="{{_themeManager.getStackedLogo()}}" >
    <div class="formFieldList">
      <div *ngIf="forgotForm.errors">
        <mat-error *ngIf="forgotForm.errors.invalidUser">Invalid username/password</mat-error>
        <mat-error *ngIf="forgotForm.errors.limitExceeded">Too many reset attempts. Try again later.</mat-error>
      </div>
      <mat-form-field>
        <input matInput placeholder="Enter your email" formControlName="email" required>
      </mat-form-field>
    </div>
    <div class="tile-footer centered">
    <button mat-button type="button" color="primary" (click)="stateChange.emit({state:'LOGIN'})">Return to Login</button>
    <button mat-raised-button type="submit" color="primary" (click)="onSave()">Next</button>
    </div>
  </div>
</form>
`,
  styleUrls: ['./auth.layout.scss']
})
export class ForgotPasswordComponent implements OnInit {
  @Output() stateChange: EventEmitter<any> = new EventEmitter();

  forgotForm = new FormGroup ({
    email: new FormControl('', [Validators.required, Validators.email])
  });

  constructor(public _themeManager: ThemeManagerService, private _cognitoService: CognitoService, private _router: Router) { }

  ngOnInit() {
  }

  onSave() {
    this.forgotForm.updateValueAndValidity();
    if (this.forgotForm.status == 'VALID') {
      (window as any).LOG_LEVEL = 'DEBUG';
      this._cognitoService.forgotPassword(this.forgotForm.value.email).then(
        success => {
          this.stateChange.emit({state: 'FORGOTPASSWORDCONFIRM', username: this.forgotForm.value.email});
          // this._router.navigate(['/public/resetPassword']);
        },
        error => {
          if (error.code == 'LimitExceededException') {
            this.forgotForm.setErrors({limitExceeded: true});
          } else {
            this.stateChange.emit({state: 'FORGOTPASSWORDCONFIRM', username: this.forgotForm.value.email});
            // this.forgotForm.setErrors({"invalidUser": true});
          }
        });
    }
  }
}

const confirmPasswordValidator:ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const confirmCheck = (control.get('password') && control.get('confirmPassword') && control.get('password').value != control.get('confirmPassword').value) ? {passwordNoMatch: true} : null;

  if (confirmCheck) {
    control.get('confirmPassword').setErrors({passwordNoMatch: true});
  }

  return null;
}

@Component({
  selector: 'app-forgot-password-confirm',
  template: `
<form [formGroup]="confirmForm" class="dashboard-tile mat-elevation-z4">
  <div class="tile-header">
    <div class="tile-header-title">
      Forgot Password Reset
    </div>
  </div>
  <div class="tile-content">
    <img mat-card-image class="tile-logo" src="{{_themeManager.getStackedLogo()}}" >
    <mat-hint>If your email address is registered with the system, you will receive an email with a confirmation code.</mat-hint>
    <div class="formFieldList">
      <div *ngIf="confirmForm.errors?.failedReset">
        <mat-error>{{confirmForm.errors.failedReset}}</mat-error>
      </div>
      <mat-form-field>
        <input matInput placeholder="Enter your email" formControlName="email" required>
      </mat-form-field>
      <mat-form-field>
        <input formControlName="confirmationCode" matInput placeholder="Confirmation Code" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Password" formControlName="password" type="password" pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$" required>
        <mat-hint>at least 8 characters, 1 uppercase, 1 lowercase, 1 number, and 1 special character</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Confirm Password" formControlName="confirmPassword" type="password" required>
        <mat-error *ngIf="confirmForm.controls.confirmPassword?.errors?.passwordNoMatch">Doesn't match password</mat-error>
      </mat-form-field>
    </div>
    <div class="tile-footer centered">
    <button mat-button type="button" color="primary" (click)="onResend()">Resend Code</button>
    <button mat-button type="button" color="primary" (click)="stateChange.emit({state:'LOGIN'})">Return to Login</button>
    <button mat-raised-button type="submit" color="primary" (click)="onSave()">Reset</button>
    </div>
  </div>
</form>
`,
  styleUrls: ['./auth.layout.scss']
})
export class ConfirmForgotPasswordComponent implements OnInit {
  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @Input() email;
  @Input() confirmationCode;

  confirmForm = new FormGroup ({
    email: new FormControl('', [Validators.required, Validators.email]),
    confirmationCode: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    confirmPassword: new FormControl('', [Validators.required])
  }, [confirmPasswordValidator]);

  constructor(public _themeManager: ThemeManagerService, private _cognitoService: CognitoService, private _router: Router) { }

  ngOnInit() {
    this.confirmForm.controls.email.setValue(this.email);
    this.confirmForm.controls.confirmationCode.setValue(this.confirmationCode);
  }

  onSave() {
    if (this.confirmForm.status == 'VALID') {
      this._cognitoService.resetPassword(this.confirmForm.value.email, this.confirmForm.value.confirmationCode, this.confirmForm.value.password).then(
        success => {
          this.stateChange.emit({state:'LOGIN'});
          // this._router.navigate(['/public/login']);
        },
        error => {
          this.confirmForm.setErrors({failedReset: error.message});
        }
      );
    }
  }

  onResend() {
      this.confirmForm.controls.email.updateValueAndValidity();
      if (this.confirmForm.controls.email.valid) {
        this._cognitoService.forgotPassword(this.confirmForm.value.email).then(
          success => {
          },
          error => {
          }
        );
      }
    }
}